import Link from 'next/link'
import ReactHtmlParser, { processNodes } from 'react-html-parser'

export const handleHtmlNode = (node, index) => {
  if (node.name == 'a') {
    return (
      <Link href={node.attribs.href} title={node.attribs.title}>
        <>{processNodes(node.children, handleHtmlNode)}</>
      </Link>
    )
  }
  if (node.name == 'p') {
    if (node.children.length == 1 && node.children[0].data?.trim() == '')
      return null

    return (
      <p>
        <>{processNodes(node.children, handleHtmlNode)}</>
      </p>
    )
  }
}

export const render = (html) =>
  ReactHtmlParser(html, {
    transform: handleHtmlNode,
  })
